import React from 'react';
import { Navbar, Nav, NavItem } from 'reactstrap';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>
          APSY TKA &#174; Assessment Prediction System Tes Kemampuan Akademik
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
